import React from "react";
import { Button } from "antd";
import utils from '../../utils';
import icons from "Common/Icons";
import { CONSTANTS } from "utils/constant";
export default class extends React.Component {
  _baseClassName = "patient-detail-video-consultation-container";
  constructor(props) {
    super(props);

    this.state = {
      data: this.props?.data || []
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.data !== prevState.data) {
      return { data: nextProps.data }
    }
    return null;
  }

  handleFunction(col, value) {
    typeof this.props.handleActions == "function" && this.props.handleActions(col, value);
  }

  render() {
    return (
      <div className={this._baseClassName}>
        <div className="video-consultation-main">
          <div className="header-container">
            <img src={icons.patient_consultaion}></img>
            <div className="header-name">{CONSTANTS.APPOINTMENT_CONSULTATION}</div>
          </div>
          {this.state.data ? (
            <div className="main-content">
              <div className="top-content">
                <div>
                  {CONSTANTS.HAVE_COMPLETED} <span className="count">{this.state.data.consultation_count || 0}</span> {this.state.data?.consultation_count > 1 ? "consultations" : "consultation"}
                </div>
                {this.state.data.is_prescribed ?
                  <div>
                    <span className="count">{this.state.data.prescription_count}</span> {CONSTANTS.MEDICINES_PRESCRIBED}
                  </div> : null}
                {this.state.data.is_casesheet ?
                  <div className="last-casesheet-label">
                    {CONSTANTS.CASESHEET_EDITED}<span className="doctor-name">{utils.FormatDate(this.state.data.casesheet_updated_on, "DATE_14")}</span>
                  </div>
                  : null}
              </div>


              <div className="bottom-content">
                {true ?
                  <Button icon={<img src={icons.arrow_icon} />} onClick={e => this.handleFunction("casesheet", this.state.data)}>
                    {CONSTANTS.VIEW_CASESHEET}
                  </Button> : null}

              </div>
            </div>
          ) : null}
          {this.state.data?.consultation_count == 0 || this.state.data == undefined ? (
            <div className="main-content error-message">
              <div>{CONSTANTS.NO_CONSULTATION}</div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
